import {getFailureActionType, getRequestActionType, getSuccessActionType} from '../../../utils';

function getErrorReducer(types) {
  let requestActions = types.map(type => getRequestActionType(type));
  let successActions = types.map(type => getSuccessActionType(type));
  let failureActions = types.map(type => getFailureActionType(type));
  return function errorReducer(state = null, action) {
    if (requestActions.includes(action.type) || successActions.includes(action.type)) {
      return null;
    } else if (failureActions.includes(action.type)) {
      return action.payload;
    } else {
      return state;
    }
  };
}

export default getErrorReducer;
